
import Vue from 'vue'
import type { TelephonyMatch } from '@/utils/telephonyLookup'

export default Vue.extend({
  name: 'TelephonyMatchCard',
  props: {
    match: {
      type: Object as () => TelephonyMatch,
      required: true,
    },
  },
  computed: {
    typeLabel(): string {
      if (this.match.kind === 'worker') {
        return this.$vuetify.lang.t('$vuetify.telephony_worker_label')
      }
      return this.$vuetify.lang.t('$vuetify.telephony_company_label')
    },
  },
})
